import { useEffect, useState } from "react";
import { Smartphone, Download, Share, CheckCircle2, ExternalLink } from "lucide-react";
import { installState, promptInstall, subscribeInstall } from "@/lib/install";

const LIVE = process.env.REACT_APP_LIVE_URL;

const Steps = ({ ios }) => (
  <ol className="text-sm text-mm-muted list-decimal pl-5 space-y-1" data-testid="install-app-steps">
    {ios ? (
      <>
        <li>Tap the <Share size={14} className="inline -mt-0.5" /> Share button in Safari.</li>
        <li>Choose <strong>Add to Home Screen</strong>, then <strong>Add</strong>.</li>
      </>
    ) : (
      <>
        <li>Open your browser menu (⋮).</li>
        <li>Tap <strong>Install app</strong> or <strong>Add to Home screen</strong>.</li>
      </>
    )}
  </ol>
);

export const InstallAppCard = () => {
  const [s, setS] = useState(installState);
  useEffect(() => subscribeInstall(() => setS(installState())), []);

  let body;
  if (s.testSite) {
    body = (
      <>
        <p className="text-sm text-mm-muted">You're on the test copy. Install from the live site so your home screen always opens your real data.</p>
        <a href={LIVE} className="mm-btn inline-flex items-center gap-2 mt-3" data-testid="install-app-open-live">
          Open live site <ExternalLink size={16} />
        </a>
      </>
    );
  } else if (s.standalone) {
    body = <p className="text-sm text-mm-muted flex items-center gap-2" data-testid="install-app-installed"><CheckCircle2 size={16} className="text-mm-success" /> Installed — you're using the app.</p>;
  } else if (s.canPrompt) {
    body = (
      <button onClick={promptInstall} className="mm-btn inline-flex items-center gap-2" data-testid="install-app-button">
        <Download size={16} /> Install Mindful Me
      </button>
    );
  } else {
    body = <Steps ios={s.ios} />;
  }

  return (
    <div className="mm-card p-5 flex gap-4 items-start" data-testid="install-app-card">
      <div className="mm-soft p-3 shrink-0"><Smartphone size={22} className="text-mm-primary" /></div>
      <div className="min-w-0 flex-1 space-y-2">
        <div className="font-semibold">Add to your home screen</div>
        {body}
      </div>
    </div>
  );
};
